import React, { useState } from "react"
import axios from "axios";
import { baseUrl } from "../index";

const UploadDoc = (props) => {
    const [photo, setPhoto] = useState("");
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    const onSubmit = (e) => {
        e.preventDefault();
        const files = document.querySelectorAll("input[type=file]");
        const formData = new FormData();
        formData.append("insurerID", props.Companyid);
        formData.append("enquiryNo", props.EnquiryNo);
        formData.append("URL", "UploadCKYCFile");
        formData.append("uploadDesc", "PostedFiles");

        files.forEach((f) => {

            if (f.value !== "")
                formData.append(f.id.toLowerCase(), f.files[0]);

        });
        axios.post(`${baseUrl}/central/centralcall/UploadFile`,  formData , { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(res => {
                if (res.data.StatusCode === 200) {
                    props.setKYCDetails({
                        Base64Photo:"",
                        Base64POI:"",
                        Base64POA: "",
                        IsRedirectUrl: false,
                        IsUploadFile: true,
                        SelectedPOA: "",
                        SelectedPOI: "",
                        SelectedPOIValue: "",
                        selectedPOAValue: ""
                    });
                    // props.onKYCSubmit();
                } else alert("Kindly Choose File");
            });
    }
    return <>

        <div className="modal fade show CkycUploadDOCVerify01" id="exampleModalDefault" style={{ display:"block" }} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content CkycUploadDOC">
                    <div className="modal-header d-block">
                        <button type="button" className="close" onClick={() => props.onKycSubmit(false)}>X</button>
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Upload Documents</h1>
                    </div>
                    <div className="modal-body">
                        <p>Upload <b>{props.title==="photo"?"Photo":"form 60"}</b> to proceed further </p>
                        <form onSubmit={onSubmit} >
                            <div className="UploadDocuments" style={{ display: photo===""?"":"none" }}>
                                <input type="file" name={props.title === "photo" ? "photo" : "form60"} onChange={async (e) => setPhoto(await toBase64(e.target.files[0]))} id={props.title === "photo" ? "photo" : "form60"} hidden />
                                <label htmlFor={props.title === "photo" ? "photo" : "form60"} className="POS_File_Upload_Box">
                                    <img src={require("../Images/upload.svg")} />
                                <p>Click to upload file</p>
                            </label>
                            </div>
                            <div style={{ display: photo === "" ? "none" : "" }} className="UIM_After">
                                <button type="button" className="close" onClick={() => setPhoto("")}>X</button>
                                <img src={photo} title={props.title } />
                            </div>

                            <button type="submit" className="btn fileUploadBtn" disabled={photo===""} >Upload Document</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>
}
export default UploadDoc;